import Vue from 'vue'
import VueRouter from 'vue-router'
import WXLogin from '../views/home/WXLogin.vue'
import Home from '../views/home/Index.vue'
import Search from '../views/home/search/Search.vue'
import Details from '../views/home/details/Details.vue'
import Video from '../views/home/details/Video.vue'
import Live from '../views/home/Live.vue'
import CatDetail from '../views/home/CatDetail.vue'
import HotTopics from '../views/home/HotTopics.vue'
import SuperiorProduct from '../views/home/SuperiorProduct.vue'
import Order from '../views/personal/Order.vue'
import WeekTime from '../views/personal/WeekTime.vue'
import Introduce from '../views/personal/Introduce.vue'
import ColumnTabbar from '../views/home/ColumnTabbar.vue'
import Register from '@/views/personal/Register'
import Lecture from '../views/lecture/Lecture'
import Login from '@/views/personal/Login'
import Layout from '@/views/Layout'
import Personal from '@/views/personal/Personal'
import ReplaceMobile from '@/views/personal/ReplaceMobile'
import Certification from '@/views/personal/Certification'
import Qualification from '@/views/personal/Qualification'
import ErrorPage from '@/views/errorPage/errorPage'

import Attention from '@/views/personal/Attention'
import Collect from '@/views/personal/Collect'

import AnVideo from '@/views/home/details/AnVideo'
import PcVideo from '@/views/home/details/PcVideo'
import Questionnaire from '@/views/questionnaire/Questionnaire'
import SubmitSuccess from '@/views/questionnaire/SubmitSuccess'
import Apply from '@/views/enrollment/Apply'
import Record from '@/views/enrollment/Record'
import Renew from '@/views/enrollment/Renew'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push

import SignIn from '@/views/SignIn'
import Question from '@/views/Question'
import ScreenShow from '@/views/ScreenShow'
import Test from '@/views/test'
// 重写了原型上的push方法，统一的处理了错误信息
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'LUMI智播'
    }
  },
  {
    path: '/wxLogin',
    name: 'WXLogin',
    component: WXLogin,
  },
  {
    path: '/qualification',
    name: 'Qualification',
    component: Qualification,
    meta: {
      title: 'LUMI智播-资质认证'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      title: 'LUMI智播-注册'
    }
  },
  {
    path: '/signIn',
    name: 'SignIn',
    component: SignIn,
    meta: {
      title: '签到'
    }
  },
  {
    path: '/questions',
    name: 'question',
    component: Question,
    meta: {
      title: '提问'
    }
  },
  {
    path: '/screenShow',
    name: 'ScreenShow',
    component: ScreenShow,
    meta: {
      title: '大屏展示'
    }
  },
  {
    path: '/superiorProduct',
    name: 'SuperiorProduct',
    component: SuperiorProduct,
    meta: {
      title: 'LUMI智播-智播优品'
    }
  }, {
    path: '/hotTopics',
    name: 'HotTopics',
    component: HotTopics,
    meta: {
      title: 'LUMI智播-热门关注'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'LUMI智播-登录'
    }
  },
  {
    path: '/replaceMobile',
    name: 'ReplaceMobile',
    component: ReplaceMobile,
    meta: {
      title: 'LUMI智播-资料修改'
    }
  },
  {
    path: '/weekTime',
    name: 'WeekTime',
    component: WeekTime,
    meta: {
      title: 'LUMI智播-本周排名'
    }
  },
  {
    path: '/introduce',
    name: 'Introduce',
    component: Introduce,
    meta: {
      title: 'LUMI智播-个人中心'
    }
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    meta: {
      title: 'LUMI智播-已购直播',
      // keepAlive: true
    }
  },
  {
    path: '/layout',
    name: 'Layout',
    component: Layout
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: {
      title: 'LUMI智播-搜索'
    }
  },
  {
    path: '/catDetail',
    name: 'CatDetail',
    component: CatDetail,
    meta: {
      title: 'LUMI智播-专题详情'
    }
  },
  {
    path: '/live',
    name: 'Live',
    component: Live,
    meta: {
      title: 'LUMI智播-直播',
      // keepAlive: true
    }
  },
  {
    path: '/details',
    name: 'Details',
    component: Details,
    meta: {
      title: 'LUMI智播-直播详情'
    }
  },
  {
    path: '/personal',
    name: 'Personal',
    component: Personal,
    meta: {
      title: 'LUMI智播-个人中心'
    }
  },
  {
    path: '/lecture',
    name: 'Lecture',
    component: Lecture,
    meta: {
      title: 'LUMI智播-讲师端'
    }
  },
  {
    path: '/certification',
    name: 'Certification',
    component: Certification,
    meta: {
      title: 'LUMI智播-完善资料'
    }
  },
  {
    path: '/video',
    name: 'Video',
    component: Video,
    meta: {
      title: 'LUMI智播-直播观看'
    }

  },
  {
    path: '/coltabbar',
    name: 'ColumnTabbar',
    component: ColumnTabbar,
    meta: {
      title: 'LUMI智播-直播',
      // keepAlive: true
    }

  },
  {
    path: '/errorPage',
    name: 'ErrorPage',
    component: ErrorPage,
    props: true
  }, {
    path: '/attention',
    name: 'Attention',
    component: Attention,
    meta: {
      title: 'LUMI智播-我的关注'
    }
  },
  {
    path: '/collect',
    name: 'Collect',
    component: Collect,
    meta: {
      title: 'LUMI智播-我的收藏'
    }
  },
  {
    path: '/anVideo',
    name: 'AnVideo',
    component: AnVideo,
    meta: {
      title: 'LUMI智播-直播'
    }
  },
  {
    path: '/pcVideo',
    name: 'PcVideo',
    component: PcVideo,
    meta: {
      title: 'LUMI智播-直播'
    }
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: Questionnaire,
    meta: {
      title: 'LUMI智播-调查问卷'
    }
  },
  {
    path: '/submitSuccess',
    name: 'SubmitSuccess',
    component: SubmitSuccess,
    meta: {
      title: 'LUMI智播-调查问卷'
    }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: Apply,
    meta: {
      title: 'LUMI智播-入会申请'
    }
  },
  {
    path: '/record',
    name: 'Record',
    component: Record,
    meta: {
      title: 'LUMI智播-入会申请'
    }
  },
  {
    path: '/renew',
    name: 'Renew',
    component: Renew,
    meta: {
      title: 'LUMI智播-续费申请'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  // sessionStorage.setItem('openId', 'ogx5ev2bFGcB6NxDgDRPGgCkzy5Q')
  //1. 过滤路由
  if (to.path.indexOf('test') != -1 || to.path.indexOf('wxLogin') != -1 || to.path.indexOf('lecture') != -1 || to.path.indexOf('screenShow') != -1 || to.path.indexOf('questions') != -1 || to.path.indexOf('signIn') != -1) {
    next()
    return
  }

  //2. 获取页面URI
  let targetUri = location.href
  let weixin = location.href.split('#')[0] + '#/wxLogin'
  localStorage.removeItem('targetUri')
  if (!(targetUri.indexOf('code=') > -1)) {
    localStorage.setItem('targetUri', targetUri)
  }

  //3.获取本地openId-》判断是否授权
  if (!sessionStorage.getItem('openId')) {
    let callback = `${process.env.VUE_APP_API_URL}live/liveUsers/callback?return_url=${encodeURIComponent(weixin)}`
    location.href = process.env.VUE_APP_API_URL + `live/liveUsers/getAuth?returnUri=${encodeURIComponent(callback)}`
    return
  } else {
    localStorage.removeItem('targetUri')
    next()
  }

})
// router.beforeEach(async (to, from, next) => {
//   sessionStorage.setItem('openId', 'o3Dn56o3oJZhHYMXmbz6OvtTrVO4')
//   next()
// })
export default router
